<script setup lang="ts">
import { computed, watch } from 'vue';
import { RouterView, useRoute } from 'vue-router';
import ShareCardDialog from './components/ShareCardDialog.vue';
import { provideAirBulletin } from './composables/useAirBulletin';
import { tierTokens } from './data/design';

const route = useRoute();
const previousDesign = computed(() => route.name === 'previous-design');

const {
  isEmbed,
  currentPsi,
  currentTier,
  mascotState,
  toastMessage,
  toastVisible,
  shareModalOpen,
} = provideAirBulletin(previousDesign);

watch(
  [previousDesign, currentPsi, currentTier],
  ([previous, psi, tier]) => {
    const reading = psi !== null && tier ? `PSI ${psi} (${tier.name}) · ` : '';
    document.title = `${reading}${previous ? 'Previous Design · ' : ''}HazePuns`;
  },
  { immediate: true },
);
</script>

<template>
  <div
    id="app-root"
    :class="[previousDesign ? 'design-previous' : 'design-current', { 'is-embed': isEmbed }]"
    :data-tier="currentTier?.id"
    :data-mascot-state="mascotState"
    :style="tierTokens"
  >
    <RouterView />
    <ShareCardDialog />
    <div
      id="toast-msg"
      v-show="!shareModalOpen"
      class="toast-msg"
      :class="{ show: toastVisible }"
      role="status"
      aria-live="polite"
    >
      {{ toastMessage }}
    </div>
  </div>
</template>
